/* eslint-disable @typescript-eslint/prefer-promise-reject-errors */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { createConfigParametersRepository } from '../configParametersRepository';
import { post } from '../utils/httpRequest';
import { createDataMeshTrackingClient } from './dataMesh';
import { handleMktSessionError } from './error';
import { checkInitialized, getContext, init } from './init';
import {
  ERROR_COMPONENT_DOM_MANDATORY,
  ERROR_COMPONENT_ID_MANDATORY,
  ERROR_EVENT_MANDATORY,
} from './messages';
import {
  getPageRenderId as getLegacyPageRenderId,
  refreshPageRenderId,
} from './pageRenderID';
import {
  buildClickRequest,
  buildDisplayedRequest,
  buildPageLoadedRequest,
} from './request';
import { buildResponse } from './response';
import { getPageRenderId } from './standalone';
import {
  setTransactionBookingId as setBookingId,
  setTransactionMembershipId as setMembershipId,
  setTransactionSearchId as setSearchId,
} from './transactionID';
import type {
  DeprecatedDatameshEventsTrackerArgs,
  MicroFrontEndConfig,
  PageLoadedHtmlDatameshEvent,
  PageLoadedTracker,
} from './types';
import {
  CLICK,
  COMPONENT_DISPLAYED,
  HTML_EVENTS_API_ROUTE,
  PAGE_LOADED,
} from './urls';

const trackComponentEvent = async (path, id) => {
  if (!id) {
    return Promise.reject({ error: ERROR_COMPONENT_ID_MANDATORY });
  }
  const pageRenderId: string = getLegacyPageRenderId();
  const request =
    path === CLICK
      ? buildClickRequest(id, pageRenderId)
      : buildDisplayedRequest(id, pageRenderId);

  return post(`${getContext()}${HTML_EVENTS_API_ROUTE}${path}`, request).then(
    () => buildResponse(request)
  );
};

const trackPageLoadedEvent = async (
  mfe: MicroFrontEndConfig
): Promise<{ event: PageLoadedHtmlDatameshEvent }> => {
  const previousPageRenderId = getLegacyPageRenderId();
  const pageRenderId = refreshPageRenderId();
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const mktSessionId = storageClient?.getCookie('mktSession') || undefined;
  if (!mktSessionId) {
    handleMktSessionError(mktSessionId);
  }
  const request = buildPageLoadedRequest(
    mktSessionId,
    previousPageRenderId,
    pageRenderId,
    mfe
  );

  return post(
    `${getContext()}${HTML_EVENTS_API_ROUTE}${PAGE_LOADED}`,
    request
  ).then(() => buildResponse(request));
};

// @deprecated
const trackClick = async ({ id }: DeprecatedDatameshEventsTrackerArgs = {}) => {
  if (!id) {
    return Promise.reject({ error: ERROR_COMPONENT_ID_MANDATORY });
  }
  const pageRenderId = getLegacyPageRenderId();
  const request = buildClickRequest(id, pageRenderId);
  return (async () => {
    await checkInitialized();
    return post(
      `${getContext()}${HTML_EVENTS_API_ROUTE}${CLICK}`,
      request
    ).then(() => buildResponse(request));
  })();
};

// @deprecated
const trackComponentDisplayed = async ({
  id,
}: DeprecatedDatameshEventsTrackerArgs = {}) => {
  await checkInitialized();
  return await trackComponentEvent(COMPONENT_DISPLAYED, id);
};

const getDOMId = (htmlElement) => htmlElement.dataset.id;

const trackDOMComponentDisplayed = async (htmlElement) => {
  await checkInitialized();
  if (htmlElement instanceof Element && getDOMId(htmlElement)) {
    return await trackComponentEvent(
      COMPONENT_DISPLAYED,
      getDOMId(htmlElement)
    );
  } else {
    return Promise.reject({ error: ERROR_COMPONENT_DOM_MANDATORY });
  }
};

const trackClickEvent = async (event) => {
  await checkInitialized();
  if (event && event.currentTarget && getDOMId(event.currentTarget)) {
    return await trackComponentEvent(CLICK, getDOMId(event.currentTarget));
  } else {
    return Promise.reject({ error: ERROR_EVENT_MANDATORY });
  }
};

const trackPageLoaded: PageLoadedTracker = async ({ mfe } = {}) => {
  await checkInitialized();
  return await trackPageLoadedEvent(mfe);
};

export {
  trackClick,
  trackComponentDisplayed,
  trackPageLoaded,
  trackDOMComponentDisplayed,
  trackClickEvent,
  init,
  setBookingId,
  setSearchId,
  setMembershipId,
  createDataMeshTrackingClient,
  getPageRenderId,
};
